// extracted by mini-css-extract-plugin
export default {"container":"normal_container__YlD1y","boxContainer":"normal_boxContainer__dodS4"};